import React from "react";
import { Container, TextContainer, Descripcion } from "./styles";

const Description = () => {
  return (
    <Container>
      <TextContainer>
        <Descripcion>
          <p>
            Desde el descubrimiento del Ozono por el físico alemán Christian
            Friedrich Schonbein En el año 1.840. Se utilizó la combinación gas
            oxígenoozono primeramente como agente para purificar el agua en 1901
            y como agente bactericida tópico y antiséptico durante la Primera
            Guerra Mundial para el tratamiento de heridas y quemaduras
            infectadas. La demostración científica de los efectos antioxidantes,
            oxigenantes, anti-inflamatorios, inmunomodulador y antisépticos del
            ozono ha ampliado los últimos 20 años la gama de aplicaciones en
            distintas áreas médicas y quirúrgicas. Actualmente es imperativo
            realizar la integración con la medicina tradicional para formar un
            profesional de salud de calidad, a esto se le conoce Medicina
            Integrativa.
            <br /> <br /> <br /> La creación de un curso de ampliación en
            “OZONOTERAPIA CLÍNICA” Surge en respuesta a la necesidad de la
            población de médicos venezolanos con distintas especialidades que
            hacen vida en el Sistema de Salud Nacional, de brindar calidad en la
            atención, evaluación integral y tener herramientas terapéuticas que
            estén al alcance de la población venezolana. Así como en la
            necesidad de apoyo y promoción de investigaciones en el área de la
            ozonoterapia por profesionales venezolanos en los últimos años
          </p>
        </Descripcion>
      </TextContainer>
    </Container>
  );
};

export default Description;
